(() => {
  const init = (root) => {
    if (!root || root.dataset.tcvReady === 'true') return;
    root.dataset.tcvReady = 'true';

    const modal = root.querySelector('[data-tcv-modal]');
    const dialog = modal?.querySelector('[role="dialog"]');
    const content = modal?.querySelector('[data-tcv-modal-content]');
    const pager = root.querySelector('[data-tcv-pager]');
    const track = pager?.querySelector('[data-tcv-track]');
    const viewport = pager?.querySelector('[data-tcv-viewport]');
    const previousPage = pager?.querySelector('[data-tcv-prev]');
    const nextPage = pager?.querySelector('[data-tcv-next]');
    if (!modal || !dialog || !content) return;

    let trigger = null;
    let previousOverflow = '';
    let pageIndex = 0;

    const updatePager = () => {
      if (!pager || !track || !viewport || !previousPage || !nextPage) return;
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const pageCount = Math.ceil(track.children.length / 4);
      if (!desktop) pageIndex = 0;
      else pageIndex = Math.min(pageIndex, Math.max(0, pageCount - 1));

      const noPagingNeeded = !desktop || pageCount <= 1;
      previousPage.hidden = noPagingNeeded;
      nextPage.hidden = noPagingNeeded;
      previousPage.disabled = pageIndex === 0;
      nextPage.disabled = pageIndex >= pageCount - 1;

      if (!desktop) {
        track.style.transform = '';
        return;
      }

      const items = [...track.children];
      const firstLeft = items[0]?.getBoundingClientRect().left ?? 0;
      const nextPageLeft = items[4]?.getBoundingClientRect().left;
      const pageDistance = nextPageLeft === undefined ? viewport.clientWidth : nextPageLeft - firstLeft;
      const remainder = items.length % 4;
      let lastPageCenterOffset = 0;
      if (remainder && pageIndex === pageCount - 1) {
        const itemWidth = items[0]?.getBoundingClientRect().width ?? 0;
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const finalGroupWidth = remainder * itemWidth + (remainder - 1) * gap;
        lastPageCenterOffset = Math.max(0, (viewport.clientWidth - finalGroupWidth) / 2);
      }
      track.style.transform = `translateX(${-pageDistance * pageIndex + lastPageCenterOffset}px)`;
    };

    if (pager && track && previousPage && nextPage) {
      previousPage.addEventListener('click', () => {
        pageIndex = Math.max(0, pageIndex - 1);
        updatePager();
      });
      nextPage.addEventListener('click', () => {
        pageIndex = Math.min(Math.ceil(track.children.length / 4) - 1, pageIndex + 1);
        updatePager();
      });
      pager.__tcvUpdatePager = updatePager;
      updatePager();
    }

    const close = () => {
      if (modal.hidden) return;
      content.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
        video.load();
      });
      content.replaceChildren();
      modal.hidden = true;
      document.body.style.overflow = previousOverflow;
      if (trigger?.isConnected) trigger.focus();
      trigger = null;
    };

    const open = (button) => {
      const template = button.parentElement?.querySelector('template[data-tcv-content]');
      if (!template) return;
      trigger = button;
      previousOverflow = document.body.style.overflow;
      content.replaceChildren(template.content.cloneNode(true));
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      dialog.focus();
      const video = content.querySelector('video');
      if (video) {
        video.load();
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      }
    };

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-tcv-open]');
      if (button && root.contains(button)) {
        open(button);
        return;
      }
      if (event.target.closest('[data-tcv-close]')) close();
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab' || modal.hidden) return;
      const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])')]
        .filter((element) => element.getClientRects().length > 0);
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  const boot = () => document.querySelectorAll('.topfinel-creator-videos').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (target.matches?.('.topfinel-creator-videos')) init(target);
    else target.querySelectorAll?.('.topfinel-creator-videos').forEach(init);
  });
  let resizeQueued = false;
  window.addEventListener('resize', () => {
    if (resizeQueued) return;
    resizeQueued = true;
    window.requestAnimationFrame(() => {
      resizeQueued = false;
      document.querySelectorAll('[data-tcv-pager]').forEach((pager) => pager.__tcvUpdatePager?.());
    });
  }, { passive: true });
})();
